/**
 * @generated SignedSource<<1fff7a64f5920ff070b3315ab5edb188>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PropHouseAuctionStatus = "ACTIVE" | "EXECUTED" | "PENDING" | "PROPOSING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PropHouseAuctionRowActivityFragment$data = {
  readonly numProposals: number;
  readonly proposalEndTime: string;
  readonly startTime: string;
  readonly status: PropHouseAuctionStatus;
  readonly votingEndTime: string;
  readonly " $fragmentType": "PropHouseAuctionRowActivityFragment";
};
export type PropHouseAuctionRowActivityFragment$key = {
  readonly " $data"?: PropHouseAuctionRowActivityFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PropHouseAuctionRowActivityFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropHouseAuctionRowActivityFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numProposals",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "proposalEndTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votingEndTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startTime",
      "storageKey": null
    }
  ],
  "type": "PropHouseAuction",
  "abstractKey": null
};

(node as any).hash = "8cd35f53637c96408aec4b235258574e";

export default node;
